import { Page } from '@/core/architecture'

import { MyOwnedTicketsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyOwnedTickets Page
 * Implemented as a practical sample.
 */
export const MyOwnedTickets: Page = () => {
  const { state, actions } = useViewModel()

  return <MyOwnedTicketsTemplate state={state} {...actions} />
}
